export default "__VITE_ASSET__e84ed97f__"